import tinymce from 'tinymce';
import 'tinymce/models/dom'
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';

export default tinymce;
